export default "__VITE_ASSET__561ef0dd__"